import React from "react";

const Magnetic = ({
  as: Component = "button",
  children,
  setHoveredElement,
  onClick,
  ...props
}) => {
  return (
    <Component
      onMouseEnter={(e) => {
        if (typeof setHoveredElement === "function") {
          setHoveredElement(e.currentTarget.getBoundingClientRect());
        }
      }}
      onMouseLeave={() => {
        if (typeof setHoveredElement === "function") {
          setHoveredElement(null);
        }
      }}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Magnetic;
